import React from 'react';

import {
    Box,
    Card,
    CardContent,
    Grid,
    Skeleton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const Placeholder = () => (
    <Card sx={{ display: 'flex' }}>
        <Grid container>
            <Grid size={{ lg: 2, md: 3, sm: 4, xs: 6 }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                    <Skeleton variant="rectangular" height={180} />
                    <Typography
                        align="center"
                        variant="caption"
                        color="text.secondary"
                        component="div"
                    >
                        <Skeleton></Skeleton>
                    </Typography>
                </CardContent>
            </Grid>

            <Grid size={{ lg: 10, md: 9, sm: 8, xs: 6 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h6">
                            <Skeleton></Skeleton>
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                        >
                            <Skeleton></Skeleton>
                        </Typography>
                    </CardContent>
                </Box>
            </Grid>
        </Grid>
    </Card>
);

const PlaceholderProductHeader = ({ children, ready }) => {
    return <>{ready ? <Placeholder /> : children}</>;
};

PlaceholderProductHeader.propTypes = {
    children: PropTypes.node,
    ready: PropTypes.bool,
};

export default PlaceholderProductHeader;
